import { useAppConfigContext } from "contexts/AppConfigContext";

const useAppConfig = ({ enabled = true } = {}) => {
  const context = useAppConfigContext();

  return {
    ...context,
    loading: enabled ? context.loading : false,
  };
};

export default useAppConfig;
